import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import TrackingStepsComponent from "./components/TrackingStepsComponent/TrackingStepsComponent";
import stl from "./DetailsComponent.module.css";
import InquiryComponent from "@/pages/tracking/components/SharedComponents/DetailsComponent/components/InquireyComponent/InquiryComponent";
import ContactUsNew from "@/pages/tracking/components/SharedComponents/DetailsComponent/components/ContactUsNew/ContactUsNew";
import useBoolean from "@hooks/useBoolean";

//@ts-ignore

import useHelpers from "@hooks/useHelpers";
import ContactAgentComponent from "@/pages/tracking/components/SharedComponents/DetailsComponent/components/ContactAgentComponent/ContactAgentComponent";
import { api__cancelWarranty } from "@/apis/orderTracking/api__getOrderTracking";
import { api__setWarrantyRemainingPayment, api__saveVasOrCreatePaymentSession } from "@/apis/checkout/remainingPayments";
import { storeWarrantySession } from "@/pages/tracking/warranty-payment/WarrantyMoyasarPaymentPage";
import { storeWarrantyGtmData } from "@/pages/tracking/warranty-payment/warrantyGtmStorage";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import { trackEvents } from "@/common/events/events";
import InfoDetailsComponentNew from "@/pages/tracking/components/SharedComponents/DetailsComponent/components/InfoDetailsComponent/InfoDetailsComponentNew";
import useIsMobile from "@hooks/useIsMobile";
import { CDN_LINK } from "@globalConfig";
import { useLang } from "@/common/Contexts/LanguageContext";
import TrackingContactModal from "@/pages/tracking/components/SharedComponents/DetailsComponent/components/ContactUsModal/TrackingContactModal";
import WarrantyUpsellComponent from "@/pages/tracking/components/SharedComponents/DetailsComponent/components/WarrantyUpsellComponent/WarrantyUpsellComponent";
import WarrantyExtendedCard from "@/pages/tracking/components/SharedComponents/DetailsComponent/components/WarrantyUpsellComponent/WarrantyExtendedCard";
import UpgradeWarrantyModal from "@/pages/tracking/components/SharedComponents/DetailsComponent/components/WarrantyUpsellComponent/UpgradeWarrantyModal";
import UpgradeWarrantyModalContent from "@/pages/tracking/components/SharedComponents/DetailsComponent/components/WarrantyUpsellComponent/UpgradeWarrantyModalContent";
import { serverUrl } from "@globalConfig";
import { ORDER_STEPS } from "@/pages/tracking/constants/orderSteps";
var toWarrantyOption = function toWarrantyOption(item) {
  var _item$price, _item$badge;
  return {
    id: item.id,
    name: item.title,
    duration: "",
    mileage: item.subtitle,
    price: (item === null || item === void 0 ? void 0 : (_item$price = item.price) === null || _item$price === void 0 ? void 0 : _item$price.current) === 0 ? item.price.current || null : item.price.current_formatted || null,
    original_price: item.price.original_formatted,
    badge_label: (_item$badge = item.badge) === null || _item$badge === void 0 ? void 0 : _item$badge.text
  };
};
var DetailsComponent = function DetailsComponent(_ref) {
  var _details$warrantyV, _warrantyV2$items$map, _warrantyV2$items, _warrantyV2$selected, _warrantyV2$selected$, _warrantyOptions$, _warrantyV2$selected$2, _warrantyV2$selected2, _warrantyV2$selected3, _details$payment_type, _warrantyV2$items2, _warrantyV2$items$fin, _warrantyV2$selected$3, _warrantyV2$selected4, _warrantyV2$selected5, _details$headerMessag, _details$headerMessag2, _details$headerMessag3, _details$headerMessag4, _ref3, _ref5, _details$vat;
  var details = _ref.details,
    isCancelled = _ref.isCancelled,
    isFinance = _ref.isFinance,
    allOfferedDoc = _ref.allOfferedDoc,
    financeCancelled = _ref.financeCancelled,
    onRefreshOrder = _ref.onRefreshOrder;
  var popup = useBoolean();
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo,
    navigateToHard = _useHelpers.navigateToHard;
  var isMobile = useIsMobile();
  var lang = useLang();
  var _useSession = useSession(),
    user = _useSession.user;
  var upgradeWarranty = useBoolean();
  var _useState = useState(null),
    upgradeItemId = _useState[0],
    setUpgradeItemId = _useState[1];
  var _useState2 = useState(null),
    upgradeWarrantyDetails = _useState2[0],
    setUpgradeWarrantyDetails = _useState2[1];
  var warrantyV2 = (_details$warrantyV = details === null || details === void 0 ? void 0 : details.warrantyV2) !== null && _details$warrantyV !== void 0 ? _details$warrantyV : null;
  var warrantyOptions = (_warrantyV2$items$map = warrantyV2 === null || warrantyV2 === void 0 ? void 0 : (_warrantyV2$items = warrantyV2.items) === null || _warrantyV2$items === void 0 ? void 0 : _warrantyV2$items.map(toWarrantyOption)) !== null && _warrantyV2$items$map !== void 0 ? _warrantyV2$items$map : [];
  var initialWarranty = warrantyV2 !== null && warrantyV2 !== void 0 && warrantyV2.selected ? {
    id: warrantyV2.selected.id,
    name: warrantyV2.selected.title,
    duration: String(warrantyV2.selected.years),
    mileage: warrantyV2.selected.subtitle,
    price: ((_warrantyV2$selected = warrantyV2.selected) === null || _warrantyV2$selected === void 0 ? void 0 : (_warrantyV2$selected$ = _warrantyV2$selected.price) === null || _warrantyV2$selected$ === void 0 ? void 0 : _warrantyV2$selected$.current) === 0 ? warrantyV2.selected.price.current.toString() || null : warrantyV2.selected.price.current_formatted || null,
    original_price: warrantyV2.selected.price.original_formatted
  } : (_warrantyOptions$ = warrantyOptions[0]) !== null && _warrantyOptions$ !== void 0 ? _warrantyOptions$ : null;
  var isDefaultWarrantySelected = ((_warrantyV2$selected$2 = warrantyV2 === null || warrantyV2 === void 0 ? void 0 : (_warrantyV2$selected2 = warrantyV2.selected) === null || _warrantyV2$selected2 === void 0 ? void 0 : (_warrantyV2$selected3 = _warrantyV2$selected2.price) === null || _warrantyV2$selected3 === void 0 ? void 0 : _warrantyV2$selected3.current) !== null && _warrantyV2$selected$2 !== void 0 ? _warrantyV2$selected$2 : 0) === 0;
  var isBnpl = ["tamara", "amwal", "tabby"].includes((_details$payment_type = details === null || details === void 0 ? void 0 : details.payment_type) !== null && _details$payment_type !== void 0 ? _details$payment_type : "");

  // Show simplified read-only card when there's exactly one non-default warranty item
  var isExtendedSingleOption = (warrantyV2 === null || warrantyV2 === void 0 ? void 0 : (_warrantyV2$items2 = warrantyV2.items) === null || _warrantyV2$items2 === void 0 ? void 0 : _warrantyV2$items2.length) === 1 && !!(details !== null && details !== void 0 && details.warrantyPriceDetailsV3);
  var upgradeItem = (_warrantyV2$items$fin = warrantyV2 === null || warrantyV2 === void 0 ? void 0 : warrantyV2.items.find(function (i) {
    return i.id === upgradeItemId;
  })) !== null && _warrantyV2$items$fin !== void 0 ? _warrantyV2$items$fin : null;
  var isDowngradeInModal = upgradeItem ? upgradeItem.price.current < ((_warrantyV2$selected$3 = warrantyV2 === null || warrantyV2 === void 0 ? void 0 : (_warrantyV2$selected4 = warrantyV2.selected) === null || _warrantyV2$selected4 === void 0 ? void 0 : (_warrantyV2$selected5 = _warrantyV2$selected4.price) === null || _warrantyV2$selected5 === void 0 ? void 0 : _warrantyV2$selected5.current) !== null && _warrantyV2$selected$3 !== void 0 ? _warrantyV2$selected$3 : 0) : false;
  var isCollectPayment = (details === null || details === void 0 ? void 0 : details.current_step) === ORDER_STEPS.COLLECT_PAYMENT;
  var _useState3 = useState(initialWarranty),
    selectedWarranty = _useState3[0],
    setSelectedWarranty = _useState3[1];
  var _useState4 = useState(false),
    isWarrantyUpdating = _useState4[0],
    setIsWarrantyUpdating = _useState4[1];
  var handleWarrantySelect = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(option) {
      var updatedOrder;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            setSelectedWarranty(option);
            setIsWarrantyUpdating(true);
            _context.n = 1;
            return api__setWarrantyRemainingPayment(details === null || details === void 0 ? void 0 : details.order_uuid, option.id);
          case 1:
            updatedOrder = _context.v;
            setIsWarrantyUpdating(false);
            return _context.a(2, !!updatedOrder);
        }
      }, _callee);
    }));
    return function handleWarrantySelect(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleReturnClick = function handleReturnClick() {
    sessionStorage.setItem("orderData-".concat(details === null || details === void 0 ? void 0 : details.order_uuid), JSON.stringify({
      order_id: details === null || details === void 0 ? void 0 : details.id,
      order_uuid: details === null || details === void 0 ? void 0 : details.order_uuid,
      order_type: isFinance ? 2 : 1,
      isFinance: isFinance,
      city_id: details === null || details === void 0 ? void 0 : details.city_id
    }));
    navigateTo("/tracking-return-wizard/" + (details === null || details === void 0 ? void 0 : details.order_uuid));
  };
  var handleWarrantyCancel = function handleWarrantyCancel() {
    upgradeWarranty.setFalse();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: ["container", stl.container].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: [stl.tamweelDColumnsContainer, "m-hide"].join(" ")
  }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null, (details === null || details === void 0 ? void 0 : (_details$headerMessag = details.headerMessage) === null || _details$headerMessag === void 0 ? void 0 : _details$headerMessag.descriptionMessage) && (details === null || details === void 0 ? void 0 : (_details$headerMessag2 = details.headerMessage) === null || _details$headerMessag2 === void 0 ? void 0 : _details$headerMessag2.titleMessage) && /*#__PURE__*/React.createElement("div", {
    className: [stl.headerNote].join(" ")
  }, /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement("i", null), details === null || details === void 0 ? void 0 : (_details$headerMessag3 = details.headerMessage) === null || _details$headerMessag3 === void 0 ? void 0 : _details$headerMessag3.titleMessage), /*#__PURE__*/React.createElement("p", null, details === null || details === void 0 ? void 0 : (_details$headerMessag4 = details.headerMessage) === null || _details$headerMessag4 === void 0 ? void 0 : _details$headerMessag4.descriptionMessage)))), /*#__PURE__*/React.createElement("div", {
    className: stl.tamweelDColumnsContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-3 md:max-w-[40%]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-9 md:bg-white md:rounded-lg md:shadow-[0px_2px_9px_0px_rgba(0,0,0,0.10)] md:overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "md:bg-[#F9F9F9]"
  }, isFinance ? /*#__PURE__*/React.createElement("div", {
    className: "flex w-full justify-center"
  }, lang === "ar" ? /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/tracking-details/delivered.png",
    alt: "image"
  }) : /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/tracking-details/delivered.png",
    alt: "image"
  })) : /*#__PURE__*/React.createElement("div", {
    className: "flex w-full justify-center"
  }, /*#__PURE__*/React.createElement("img", {
    src: details === null || details === void 0 ? void 0 : details.step_img,
    alt: "image step"
  }))), !isMobile && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "px-4 pb-4"
  }, /*#__PURE__*/React.createElement(InfoDetailsComponentNew, {
    details: details,
    allOfferedDoc: allOfferedDoc,
    isFinance: isFinance,
    headerMessage: details === null || details === void 0 ? void 0 : details.headerMessage
  })))), /*#__PURE__*/React.createElement("div", null, !isMobile && (details === null || details === void 0 ? void 0 : details.warrantyV2) && (isExtendedSingleOption ? /*#__PURE__*/React.createElement(WarrantyExtendedCard, {
    warrantyPriceDetailsV3: details.warrantyPriceDetailsV3
  }) : /*#__PURE__*/React.createElement(WarrantyUpsellComponent, {
    warrantyV2: details.warrantyV2,
    warrantyPriceDetailsV3: details === null || details === void 0 ? void 0 : details.warrantyPriceDetailsV3,
    isBnpl: isBnpl,
    onExtend: function onExtend(itemId, details) {
      setUpgradeItemId(itemId);
      setUpgradeWarrantyDetails(details);
      upgradeWarranty.setTrue();
    },
    order_id: details === null || details === void 0 ? void 0 : details.id,
    user_id: user === null || user === void 0 ? void 0 : user.id,
    referral_location: "tracking_order",
    order_type: (_ref3 = details.payment_type) !== null && _ref3 !== void 0 ? _ref3 : 'cash',
    onCancelExtension: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _context2.n = 1;
            return api__cancelWarranty(details.order_uuid);
          case 1:
            return _context2.a(2, _context2.v);
        }
      }, _callee2);
    })),
    onCancelSuccess: function onCancelSuccess(years) {
      var _details$id, _details$payment_type2;
      trackEvents("warranty_canceled", {
        order_id: (_details$id = details.id) !== null && _details$id !== void 0 ? _details$id : null,
        referral_location: "tracking_order",
        order_type: (_details$payment_type2 = details.payment_type) !== null && _details$payment_type2 !== void 0 ? _details$payment_type2 : "cash",
        selected_warranty: years
      });
      onRefreshOrder === null || onRefreshOrder === void 0 ? void 0 : onRefreshOrder();
    }
  }))), /*#__PURE__*/React.createElement("div", null, details !== null && details !== void 0 && details.is_return_eligible ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement(InquiryComponent, {
    onClick: popup.setTrue
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement(ContactAgentComponent, {
    details: details,
    className: stl.boxShadow
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "bg-white rounded-tr-[32px] rounded-tl-[32px] shadow-[0px_-12px_32px_0px_rgba(107,107,107,0.06)] overflow-hidden px-4 py-6 flex flex-col gap-4 w-full md:rounded-lg"
  }, isMobile && /*#__PURE__*/React.createElement(InfoDetailsComponentNew, {
    details: details,
    allOfferedDoc: allOfferedDoc,
    isFinance: isFinance,
    headerMessage: details === null || details === void 0 ? void 0 : details.headerMessage
  }), isMobile && (details === null || details === void 0 ? void 0 : details.warrantyV2) && (isExtendedSingleOption ? /*#__PURE__*/React.createElement(WarrantyExtendedCard, {
    warrantyPriceDetailsV3: details.warrantyPriceDetailsV3
  }) : /*#__PURE__*/React.createElement(WarrantyUpsellComponent, {
    warrantyV2: details.warrantyV2,
    warrantyPriceDetailsV3: details === null || details === void 0 ? void 0 : details.warrantyPriceDetailsV3,
    isBnpl: isBnpl,
    onExtend: function onExtend(itemId, details) {
      setUpgradeItemId(itemId);
      setUpgradeWarrantyDetails(details);
      upgradeWarranty.setTrue();
    },
    order_id: details === null || details === void 0 ? void 0 : details.id,
    user_id: user === null || user === void 0 ? void 0 : user.id,
    referral_location: "tracking_order",
    order_type: (_ref5 = details.payment_type) !== null && _ref5 !== void 0 ? _ref5 : 'cash',
    onCancelExtension: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            _context3.n = 1;
            return api__cancelWarranty(details.order_uuid);
          case 1:
            return _context3.a(2, _context3.v);
        }
      }, _callee3);
    })),
    onCancelSuccess: function onCancelSuccess(years) {
      var _details$id2, _details$payment_type3;
      trackEvents("warranty_canceled", {
        order_id: (_details$id2 = details.id) !== null && _details$id2 !== void 0 ? _details$id2 : null,
        referral_location: "tracking_order",
        order_type: (_details$payment_type3 = details.payment_type) !== null && _details$payment_type3 !== void 0 ? _details$payment_type3 : "cash",
        selected_warranty: years
      });
      onRefreshOrder === null || onRefreshOrder === void 0 ? void 0 : onRefreshOrder();
    }
  })), /*#__PURE__*/React.createElement(TrackingStepsComponent, {
    details: details,
    isFinance: isFinance
  })), /*#__PURE__*/React.createElement(TrackingContactModal, {
    isOpen: popup.value,
    onClose: popup.setFalse
  }, /*#__PURE__*/React.createElement(ContactUsNew, {
    phoneNumber: details.sales_person.phone_number,
    showReturn: details === null || details === void 0 ? void 0 : details.is_return_eligible,
    onClickReturn: handleReturnClick
  })), /*#__PURE__*/React.createElement(UpgradeWarrantyModal, {
    isOpen: upgradeWarranty.value,
    onClose: handleWarrantyCancel
  }, /*#__PURE__*/React.createElement(UpgradeWarrantyModalContent, {
    isBnpl: isBnpl,
    item: upgradeItem,
    vat: (_details$vat = details === null || details === void 0 ? void 0 : details.vat) !== null && _details$vat !== void 0 ? _details$vat : null,
    isDowngrade: isDowngradeInModal,
    isCollectPayment: isCollectPayment,
    warrantyDetails: upgradeWarrantyDetails,
    onConfirm: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      var successUrl, failureUrl, apiResponse, _apiResponse$paymentS, _details$payment_type4, moyasarSession;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            successUrl = "".concat(serverUrl, "/").concat(lang === "en" ? "en/" : "", "site/warranty-payment/payment-processing");
            failureUrl = "".concat(serverUrl, "/").concat(lang === "en" ? "en/" : "", "site/warranty-payment/payment-processing");
            _context4.n = 1;
            return api__saveVasOrCreatePaymentSession({
              order_id: details.id,
              warranty_id: upgradeItemId,
              success_url: successUrl,
              failure_url: failureUrl
            });
          case 1:
            apiResponse = _context4.v;
            if (!(apiResponse !== null && apiResponse !== void 0 && apiResponse.paymentSession)) {
              _context4.n = 2;
              break;
            }
            moyasarSession = apiResponse === null || apiResponse === void 0 ? void 0 : (_apiResponse$paymentS = apiResponse.paymentSession) === null || _apiResponse$paymentS === void 0 ? void 0 : _apiResponse$paymentS.paymentSession;
            storeWarrantyGtmData({
              order_id: details.id,
              referral_location: "tracking_order",
              order_type: (_details$payment_type4 = details.payment_type) !== null && _details$payment_type4 !== void 0 ? _details$payment_type4 : null,
              selected_warranty: upgradeItem.years
            });
            storeWarrantySession(moyasarSession);
            navigateToHard("/site/warranty-payment/payment");
            return _context4.a(2);
          case 2:
            if (isCollectPayment) {
              navigateToHard("/paylink/".concat(details.order_uuid));
            } else {
              upgradeWarranty.setFalse();
              onRefreshOrder === null || onRefreshOrder === void 0 ? void 0 : onRefreshOrder();
            }
          case 3:
            return _context4.a(2);
        }
      }, _callee4);
    })),
    onKeep: handleWarrantyCancel
  }))));
};
export default DetailsComponent;